import api from 'api'
import { CACHE_TAG_CONFIGURED_SERVICES_LIST } from 'api/cacheTagTypes'

const extendedApi = api.injectEndpoints({
  endpoints: build => ({
    resetGracePeriod: build.mutation({
      query: body => ({
        url: '/api/v1/core/fee/rental/reset-grace-period',
        method: 'POST',
        body,
      }),
      invalidatesTags: [CACHE_TAG_CONFIGURED_SERVICES_LIST],
    }),
    undoGracePeriodReset: build.mutation({
      query: body => ({
        url: '/api/v1/core/fee/rental/undo-reset',
        method: 'POST',
        body,
      }),
      invalidatesTags: [CACHE_TAG_CONFIGURED_SERVICES_LIST],
    }),
  }),
})

export const { useResetGracePeriodMutation, useUndoGracePeriodResetMutation } = extendedApi
